export const MANIFEST_VERSION = 2;

/**
 * Builds the manifest the player reads.
 *
 * Segments are referenced by FILE NAME only (seg-N.enc). The player resolves
 * them against the manifest's own location, so the manifest keeps working if
 * the storage host, folder or proxy changes. (The old format stored absolute
 * URLs that were never updated, which made the player fetch the wrong file.)
 *
 * @param {Object} p
 * @param {string} p.contentId
 * @param {{start:number,end:number,init?:boolean,startTime:number|null}[]} p.parts
 * @param {string[]} p.ivs     base64 IVs, one per part
 * @param {number[]} p.sizes   encrypted byte length of each part
 */
export function buildManifest({
  contentId,
  mime,
  width,
  height,
  duration,
  durationEstimated,
  timeIndexed,
  parts,
  ivs,
  sizes,
}) {
  return {
    version: MANIFEST_VERSION,
    contentId,
    cipher: "AES-256-GCM",
    mime,
    width: width || 0,
    height: height || 0,
    duration: duration || 0,
    durationEstimated: !!durationEstimated,
    timeIndexed: !!timeIndexed,
    segments: parts.map((p, i) => ({
      index: i,
      file: `seg-${i}.enc`,
      iv: ivs[i],
      size: sizes[i],
      init: !!p.init,
      startTime: p.startTime ?? null,
    })),
  };
}

export function serializeManifest(manifest) {
  return JSON.stringify(manifest);
}